import fetch from '../../utils/fetch';

export function error(error) {
    return { type: 'SONG_SHOW_ERROR', error };
}

export function loading(loading) {
    return { type: 'SONG_SHOW_LOADING', loading };
}

export function retrieved(retrieved) {
    return { type: 'SONG_SHOW_RETRIEVED_SUCCESS', retrieved };
}

export function showSongChords(show) {
    return { type: 'SONG_SHOW_CHORDS', show };
}

export function retrieve(id) {
    return dispatch => {
        dispatch(loading(true));

        return fetch(id)
            .then(response => response.json())
            .then(data => {
                dispatch(loading(false));
                dispatch(retrieved(data));
            })
            .catch(e => {
                dispatch(loading(false));
                dispatch(error(e.message));
            });
    };
}

export function reset() {
    return { type: 'SONG_SHOW_RESET' };
}

export function showChords() {
    return dispatch => {
        dispatch(showSongChords(true));
    };
}

export function hideChords() {
    return dispatch => {
        dispatch(showSongChords(false));
    };
}



// WEBPACK FOOTER //
// ./src/actions/song/show.js